// Library methods
import { useTranslation } from "react-i18next";
import { useCallback, useContext, useMemo } from "react";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DefaultModal from "../DefaultModal";

// Styles
import { ModalCustomCancel } from "../../../styles/muiStylesHelper";
import { DeviceAppVersionContext } from "../../../contexts/DeviceContext";

import controllerOverlaidImage from "../../../assets/images/instruction/PicoController (WithPicoButtonOverlay).jpeg";
import arborWifiImage from "../../../assets/images/instruction/ArborWiFiConnected (WithOverlay).jpeg";
import arborExitOverlaidImage from "../../../assets/images/instruction/ArborExitWiFi (WithOverlay).jpeg";
import arborVersionOverlaidImage from "../../../assets/images/instruction/RetinaLogikAssignmentUI (WithOverlay).jpeg";
import arborVersionLobbyImage from "../../../assets/images/instruction/ArborLobbyProd (WithOverlay).jpeg";

const DeviceUpdateInstructionPopup = () => {
  const { t } = useTranslation();
  const { openInstruction, setOpenInstruction } = useContext(
    DeviceAppVersionContext
  );
  const handleClick = useCallback(() => {
    setOpenInstruction(false);
  }, [setOpenInstruction]);

  const updateInstructions = useMemo(
    () => [
      {
        header: "1",
        text: "device_update_instruction1",
        img: controllerOverlaidImage,
      },
      { header: "2", text: "device_update_instruction2", img: arborWifiImage },
      {
        header: "2a",
        text: "device_update_instruction2_1",
        img: arborExitOverlaidImage,
      },
      { header: "3", text: "device_update_instruction3", img: null },
      {
        header: "4",
        text: "device_update_instruction4",
        img: arborVersionLobbyImage,
      },
      {
        header: "",
        text: "device_update_instruction4_1",
        img: arborVersionOverlaidImage,
      },
      { header: "5", text: "device_update_instruction5", img: null },
    ],
    []
  );

  // Utility function to split text according to your specified criteria
  const splitText = useCallback(
    (instruction) => {
      const parts = t(instruction.text).split(/(?<=\.\s)(?=[\w\s]{2})/);

      return parts.map((sentence, index) => (
        <Typography key={index}>
          {index === 0 && instruction.header
            ? instruction.header + ". " + sentence
            : index
              ? `　${sentence}`
              : sentence}
        </Typography>
      ));
    },
    [t]
  );

  return (
    <DefaultModal
      isOpen={openInstruction}
      onClose={handleClick}
      title={t("device_update_instruction_title")}
      maxWidth="sm"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={handleClick}>
            {t("button_close")}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        {updateInstructions.map((instruction, index) => (
          <div key={index}>
            <Typography
              id={`modal-modal-description-${index}`}
              textAlign="center"
            >
              {splitText(instruction)}
            </Typography>
            {instruction.img && (
              <div
                style={{
                  width: "75%",
                  display: "flex",
                  margin: "0 auto",
                  marginTop: "20px",
                }}
              >
                <img
                  width="100%"
                  src={instruction.img}
                  alt={instruction.text}
                  style={{ borderRadius: "10px" }}
                />
              </div>
            )}
          </div>
        ))}
      </Grid>
    </DefaultModal>
  );
};

export default DeviceUpdateInstructionPopup;
